import React from 'react';
import format from 'date-fns/format';
import classNames from 'classnames';

import FopViewType from '../fopViews/FopViewType';
import SubscribeControlsContainer from 'apps/subscriptions/containers/SubscribeControlsContainer';
import SubscriptionsInfoBoxContainer from 'apps/subscriptions/containers/SubscriptionsInfoBoxContainer';
import { VIEW_TYPE_PREFERENCE_LIST } from 'apps/catalogue/actions/catalogue';
import SubscriptionsPriceContent from 'apps/subscriptions/components/fopPartials/SubscriptionsPriceContent';
import SubscriptionPageComponent from 'apps/fops/analytics/components/SubscriptionPageComponent';
import ProductImpression from 'apps/gtm/components/ProductImpression';
import PromotionImpression from 'apps/gtm/components/PromotionImpression';

export default class SubscriptionsFopElementsFactory {
  fopViewType = FopViewType.REGULAR_FOP;

  getFopTypeClass = () => classNames(
    this.className,
    'fops-regular',
    'fops-subscriptions',
    `fops-${this.viewTypePreference}`,
  );

  constructor({
    productsBySku,
    subscriptionsBySku,
    viewTypePreference,
    betaFeatures,
    className,
    disableInfoBox,
    isRecommendation,
  }) {
    this.productsBySku = productsBySku;
    this.subscriptionsBySku = subscriptionsBySku;
    this.viewTypePreference = viewTypePreference === VIEW_TYPE_PREFERENCE_LIST ? 'list' : 'shelf';
    this.hasQuickMenu = false;
    this.betaFeatures = betaFeatures;
    this.className = className;
    this.disableInfoBox = disableInfoBox;
    this.isRecommendation = isRecommendation;
  }

  getFopControlsComponent = ({ product, collectionFopIdx } = {}) => (
    <div>
      {!this.disableInfoBox && (
        <SubscriptionsInfoBoxContainer
          sku={product.sku}
        />
      )}
      <SubscribeControlsContainer
        product={this.getSubscribedProduct(product.sku)}
        sku={product.sku}
        collectionFopIdx={collectionFopIdx}
        isRecommendation={this.isRecommendation}
      />
    </div>
  );

  getFopAnalyticsComponents = ({ fopType, product, fop, section, collectionOrderDetails }) => {
    const result = [
      <SubscriptionPageComponent
        key="0"
        subscription={this.subscriptionsBySku[product.sku]}
        fopType={fopType}
        product={product}
        fop={fop}
        section={section}
        collectionOrderDetails={collectionOrderDetails}
      />,
      <ProductImpression key="1" product={product} section={section} collectionOrderDetails={collectionOrderDetails} />,
    ];
    if (product.offer) {
      result.push(
        <PromotionImpression
          key="2"
          section={section}
          product={product}
          collectionOrderDetails={collectionOrderDetails}
        />
      );
    }
    return result;
  };

  getFopMiddleContent = ({ price, sku, isValueDeliveredProduct }) => { // eslint-disable-line react/prop-types
    const nextAddDateComponent = (nextDate) => {
      const date = format(nextDate, 'ddd, DD/MM');
      return (
        <div className="fop-subsciption-delivery-date">
          In your trolley on <strong>{date}</strong>
        </div>
      );
    };
    const nextAddDateLabel = this.subscriptionsBySku[sku] && this.subscriptionsBySku[sku].nextAddDate
      ? nextAddDateComponent(this.subscriptionsBySku[sku].nextAddDate)
      : '';

    const hideOffers = this.betaFeatures.includes('SUBSCRIPTIONS_HIDE_OFFERS');
    const zeroAfterPound = !this.betaFeatures.includes('CUT_ZEROS_IN_FOP_ROUND_POUND');

    const priceContent = (
      <SubscriptionsPriceContent
        hideOffers={hideOffers}
        isValueDeliveredProduct={isValueDeliveredProduct}
        price={price}
        zeroAfterPound={zeroAfterPound}
      />);

    return (
      <div>
        {priceContent}
        {nextAddDateLabel}
      </div>
    );
  };

  shouldUpdateFopControls = (sku, nextFactory) => {
    if (nextFactory === undefined) {
      return false;
    }
    return this.subscriptionsBySku[sku] !== nextFactory.subscriptionsBySku[sku];
  };

  getSubscribedProduct(sku) {
    return this.subscriptionsBySku[sku];
  }

  calculateClassNames = (sku) => (this.getSubscribedProduct(sku) ? 'subscribed-on' : '');
}
